<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{sidebarHeader}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar ref="sidebarScrollArea" class="scroll-area--data-list-add-new pt-4 pb-6" :settings="settings">
      <div class="pl-6 pr-6 pb-6">
        <div>
          <label>Name</label>
          <vs-input autocomplete="off" v-validate="'required'" name="Name" v-model="formData.name" class="w-full" />
          <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
        </div>

        <div class="pt-4 pb-6" >
          <label>Description</label>
          <vs-textarea v-model="formData.description" class="w-full" />
        </div>

        <div class="flex flex-wrap items-center justify-center">
          <img src="https://forty5degreesstorage.blob.core.windows.net/assets/pdfdocumentlogo.png" v-show="formData.uploadedFileName" @click="showUpload" width="40%" class="cursor-pointer">
        </div>
        <!-- <vs-upload @on-success="successUpload" automatic :action="uploadLocation" text="Upload Image" class="img-upload" ref="fileUpload" accept="image/png,image/gif,image/jpeg" v-show="!formData.uploadedFileName" /> -->
        <div class="flex vs-con-loading__container flex-wrap items-center justify-center pb-4">
          <v-uploader @done="successUpload" v-show="!formData.uploadedFileName" ref="fileUpload" file-type-exts="pdf" button-text="Upload PDF" language="en" file-size-limit="100MB" :preview="false" ></v-uploader>
        </div>

        <div v-show="$siteTypeId() == 1">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-divider>Module Assignment</vs-divider>
            </div>
          </div>

          <div>
            <label>Select Subject</label>
            <v-select
              @search:blur="getModules"
              ref="courseDropdown"
              class="w-full style-chooser"
              placeholder="Search / Select Course"
              :options="courses"
              v-model="courseDropdown"
            ></v-select>
          </div>
          <div class="mt-3" v-if="courseDropdown">
            <label>Select Topic</label>
            <v-select
              @search:blur="addModule"
              ref="moduleDropdown"
              class="w-full style-chooser"
              placeholder="Search / Select Module"
              :options="modules"
              v-model="moduleDropdown"
            ></v-select>
          </div>
          <div class="mt-3">
            <vs-table
              ref="selectedModulesTable"
              class="vs-con-loading__container"
              stripe
              single
              max-items="100"
              :data="selectedModules"
            >
              <template slot="thead">
                <vs-th sort-key="studentFullName">Module</vs-th>
                <vs-th></vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr
                  :data="module"
                  :key="moduleIndex"
                  v-for="(module, moduleIndex) in data"
                >
                  <vs-td :data="data[moduleIndex].label">
                    {{ module.label }}
                  </vs-td>

                  <vs-td>
                    <vs-button
                      color="danger"
                      type="flat"
                      icon-pack="feather"
                      icon="icon-x"
                      @click.stop.prevent="removeModule(module.value)"
                    ></vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button class="mr-4 vs-con-loading__container cursor-pointer" color="success" @click="updateApproach" :disabled="isDisabled" ref="addupdateButton" >{{buttoncaption}}</vs-button>
      <vs-button color="danger" class="mr-4 vs-con-loading__container cursor-pointer" v-show="formData.id" @click="deleteDocument" ref="deleteButton">Delete</vs-button>
      <vs-button type="border" class="ml-4 cursor-pointer" color="warning" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    selectedDocument: {
      type: Object,
      required: false
    },
    buttoncaption: {
      type: String,
      required: false
    },
    sidebarHeader: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      backgroundLoading:'#fff',
      formData: {
        id: 0,
        name: "",
        description: "",
        uploadedFileName: "",
        isUsed: false,
        modules: []
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      isLoading: false,
      courseDropdown: 0,
      moduleDropdown: 0,
      courses: [],
      modules: [],
      selectedModules: []
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          this.initValues();
        }
      }
    },
    uploadLocation: {
      get() {
        return this.$buildUrl("tempupload");
      }
    },
    isDisabled: function(){
      return !this.formData.uploadedFileName;
    }
  },
  watch: {
    isSidebarActive: function(val) {
      if(val){
        this.getCourses();
        if(this.selectedDocument.id) {
          this.formData.id = this.selectedDocument.id;
          this.formData.name = this.selectedDocument.name;
          this.formData.description = this.selectedDocument.description;
          this.formData.uploadedFileName = this.selectedDocument.documentUrl;
          this.formData.isUsed = this.selectedDocument.isUsed;
          
          this.selectedModules = this.selectedDocument.modules.map(function(item) {
            return { label: item.text, value: item.value };
          });
          this.getSelectedModules();
        }else {
          this.initValues();
        } 
      }
    }
  },
  methods: {
    initValues() {
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.description = "";
      this.formData.uploadedFileName = "";
      this.courseDropdown = 0;
      this.moduleDropdown = 0;
      this.selectedModules = [];
      this.formData.modules = [];
      this.isLoading = false;
      this.errors.clear();
    },
    successUpload(data) {
      this.formData.uploadedFileName = data[0].url;
      this.$vs.loading.close(this.$refs.fileUpload.$el);
      this.isLoading = false;
    },
    saveData(){
      this.$emit('saveData');
      this.$vs.loading.close(this.$refs.addupdateButton.$el);
    },
    getCourses() {
      var self = this;
      self.showLoadingOnElement("sidebarScrollArea", 1, "corners");

      var onSuccess = response => {
        self.courses = response.data.map(item => {
          return { label: item.text, value: item.value };
        });
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.sidebarScrollArea.$el);
      };

      self.$ajaxGet(self, "Course/GetSelectList", onSuccess, onFinally);
    },
    getModules() {
      var self = this;
      if (self.courseDropdown) {
        self.showLoadingOnElement("sidebarScrollArea", 1, "corners");

        var onSuccess = response => {
          self.modules = [];
          self.moduleDropdown = 0;
          self.modules = response.data.map(item => {
            return { label: item.text, value: item.value };
          });
        };
        var onFinally = function() {
          self.$vs.loading.close(self.$refs.sidebarScrollArea.$el);
        };

        self.$ajaxGet(self,"Module/GetSelectList/" + self.courseDropdown.value,onSuccess, onFinally);
      }
    },
    addModule() {
      var self = this;
      var exists = false;

      if (self.moduleDropdown) {
        for (var i = 0; i < self.selectedModules.length; i++) {
          if (self.selectedModules[i].value == self.moduleDropdown.value) {
            exists = true;
            break;
          }
        }

        if (!exists) {
          self.selectedModules.push(self.moduleDropdown);
        }
      }
    },
    removeModule(moduleId) {
      this.selectedModules = this.selectedModules.filter(function(item) {
        return item.value != moduleId;
      });
    },
    addEditDocument() {
      var self = this;
      
      self.formData.modules = self.selectedModules.map(x=>{return parseInt(x.value)});
      if (!this.formData.uploadedFileName) {
        this.$vs.notify({
          title:'Attention',
          color: "danger",
          text: "Please upload a file.",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-upload'
        });
        return;
      }

      this.$validator.validateAll().then(result => {
        var self = this;
        if (result) {
          self.showLoadingOnButton();
          if(self.formData.isUsed)
            self.showLoadingOnList();

          var onSuccess = response => {
            self.saveData();
            self.$vs.notify({
              title:'Information',
              color: "success",
              text: "Document Saved",
              position:'top-right',
              iconPack: 'feather',
              icon:'icon-save'
            });
          };
          var onFinally = function (){
            self.$vs.loading.close(self.$refs.addupdateButton.$el);
            self.$vs.loading.close(self.$parent.$el);
          };

          self.$ajaxPost(self, "document", self.formData, onSuccess, onFinally);
        } else {
          self.$vs.notify({
            title:'Attention',
            color: "warning",
            text: self.$validator.errors.items[0].msg,
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-info'
          });
        }
      });
    },
    getSelectedModules(){
      var self = this;
      var onSuccess = response =>{
        self.selectedModules = response.data.map(x=>{return {value: x.value , label: x.text}});
      };
      self.$ajaxGet(self, 'Module/SelectedList?documentId='+self.formData.id, onSuccess )
    },
    showUpload() {
      this.formData.uploadedFileName = null;
    },
    deleteDocument() {
      var self = this;
      self.showLoadingOnDeleteButton();

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Document Deleted",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
      };

      self.$ajaxDelete(self, "document/" + self.formData.id, onSuccess, onFinally);
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    showLoadingOnButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.addupdateButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnDeleteButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.deleteButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnList(){
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$parent.$el,
        scale: 1
      });
    },
    showLoadingOnUploader(){
      var self = this;
      self.isLoading = true;
      self.$vs.loading({
        type: "material",
        container: self.$refs.fileUpload.$el,
        scale: 0.45
      });
    },
    updateApproach() {
      if(this.formData.isUsed && this.formData.id)
        this.openConfirm();
      else
        this.addEditDocument();
    },
    openConfirm() {
      this.$emit("closeSidebar");
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: `Attention`,
        text: 'The selected document is being used in one or more document task(s).\n\nAre you sure you want to update it?',
        accept: this.addEditDocument,
        acceptText: "Yes, update",
        cancelText: "No, cancel"
      })
    },
  },
  mounted() {
    var self = this;
    self.$refs.fileUpload.$el.addEventListener("click", function(){
      if(!self.isLoading)
        self.showLoadingOnUploader();
      else{
        self.isLoading = false;
        self.$vs.loading.close(self.$refs.fileUpload.$el);
      }
    });
  },
  components: {
    VuePerfectScrollbar,
    vSelect
  }
};
</script>




<style lang="scss" scoped>
  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background

  {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
    .img-upload

  {
    margin-top: 2rem;
    .con-img-upload

  {
    padding: 0;
  }

  .con-input-upload {
    width: 100%;
    margin: 0;
  }

  }
  }
  }

  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }
</style>
